import { render, staticRenderFns } from "./CompanyCreateForm.vue?vue&type=template&id=54ca09c6&"
import script from "./CompanyCreateForm.vue?vue&type=script&lang=js&"
export * from "./CompanyCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports